type IntegrationSectionTitleProps = {
    title: string;
};

// Small caps heading that names each block of an integration form (connection,
// delivery, schedule) so the fields read as groups instead of one long list.
export function IntegrationSectionTitle({ title }: IntegrationSectionTitleProps) {
    return (
        <div
            className="col-span-full text-uppercase text-muted font-weight-bold"
            style={{ fontSize: "0.72rem", letterSpacing: "0.06em" }}
        >
            {title}
        </div>
    );
}
